/**
 * Markup format output 
 */
import React from 'react';
import Remarkable from 'remarkable';

export default class Markup extends React.Component {
  render() {
    let md = new Remarkable("full", { 
      html: true, 
      //linkify: true, 
      //typographer: true
    });

    return (
      <div dangerouslySetInnerHTML={
        {__html: md.render(this.props.children)}
      } />
    );
  }
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/Markup.js